"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChallengeType = void 0;
var ChallengeType;
(function (ChallengeType) {
    // pragma: allowlist nextline secret
    ChallengeType["ChangePassword"] = "ChangePassword";
    ChallengeType["CheckSyncResult"] = "CheckSyncResult";
    ChallengeType["ForgotUsernameChooseScenario"] = "ForgotUsernameChooseScenario";
    // pragma: allowlist nextline secret
    ChallengeType["ForgotPasswordChooseScenario"] = "ForgotPasswordChooseScenario";
    ChallengeType["ChooseRegistrationType"] = "ChooseRegistrationType";
    ChallengeType["ForgotUsernameConfirmIdentity"] = "ForgotUsernameConfirmIdentity";
    ChallengeType["CreateUsername"] = "CreateUsername";
    ChallengeType["Done"] = "Done";
    ChallengeType["Empty"] = "Empty";
    ChallengeType["OneTimeCode"] = "OneTimeCode";
    ChallengeType["OneTimeCodeDestination"] = "OneTimeCodeDestination";
    ChallengeType["QuestionsAndAnswers"] = "QuestionsAndAnswers";
    ChallengeType["RegistrationComplete"] = "RegistrationComplete";
    // pragma: allowlist nextline secret
    ChallengeType["StartForgotPassword"] = "StartForgotPassword";
    ChallengeType["StartForgotUsername"] = "StartForgotUsername";
    ChallengeType["StartRegistration"] = "StartRegistration";
    ChallengeType["StartSync"] = "StartSync";
    ChallengeType["StepUp"] = "StepUp";
    // pragma: allowlist nextline secret
    ChallengeType["TemporaryPassword"] = "TemporaryPassword";
    // pragma: allowlist nextline secret
    ChallengeType["UsernameAndPassword"] = "UsernameAndPassword";
    ChallengeType["UsernameRecovered"] = "UsernameRecovered";
    ChallengeType["Tethered"] = "Tethered";
    ChallengeType["ConvertedUser"] = "ConvertedUser";
    // pragma: allowlist nextline secret
    ChallengeType["ForgotPasswordDisclosure"] = "ForgotPasswordDisclosure";
    // pragma: allowlist nextline secret
    ChallengeType["ForgotPasswordConfirmIdentity"] = "ForgotPasswordConfirmIdentity";
    ChallengeType["StepUpForgot"] = "StepUpForgot";
    ChallengeType["OneTimeCodeForgotContainer"] = "OneTimeCodeForgotContainer";
    ChallengeType["CheckSyncResultForgot"] = "CheckSyncResultForgot";
    ChallengeType["RegistrationDisclosure"] = "RegistrationDisclosure";
    ChallengeType["ConfirmIdentity"] = "ConfirmIdentity";
    ChallengeType["CreateUser"] = "CreateUser";
    ChallengeType["UpdateBusiness"] = "UpdateBusiness";
    ChallengeType["LockedUser"] = "LockedUser";
})(ChallengeType = exports.ChallengeType || (exports.ChallengeType = {}));
